import { IUser, IRepository } from '@/types';
import { TAccessLevel } from '@/types';

export class RepositoryAuthorization {
  private user?: IUser;
  private repository?: IRepository;
  private userRole: TAccessLevel;

  private getUserRole(): TAccessLevel {
    return this.repository?.access_level || 'none';
  }

  constructor({ user, repository }: { user?: IUser; repository?: IRepository }) {
    this.user = user;
    this.repository = repository;
    this.userRole = this.getUserRole();
  }

  private isRepositoryOwner(): boolean {
    return this.repository?.created_by?.id === this.user?.id && this.repository?.access_level === 'admin';
  }

  private isRepositoryAdmin(): boolean {
    return this.userRole === 'admin';
  }

  private isRepositoryEditor(): boolean {
    return ['admin', 'editor'].includes(this.userRole);
  }

  private isRepositoryViewer(): boolean {
    return ['admin', 'editor', 'viewer'].includes(this.userRole);
  }

  canView(): boolean {
    if (this.repository?.is_public) {
      return true;
    }
    return this.isRepositoryViewer();
  }

  canEdit(): boolean {
    return this.isRepositoryEditor();
  }

  canCommit(): boolean {
    return this.isRepositoryEditor();
  }

  canCreateEvaluations(): boolean {
    return this.isRepositoryEditor();
  }

  canAccessEvaluations(): boolean {
    return this.isRepositoryEditor();
  }

  canRunEvaluations(): boolean {
    return this.isRepositoryEditor();
  }

  canCompare(): boolean {
    return this.isRepositoryEditor();
  }

  canCreateNotebooks(): boolean {
    return this.isRepositoryEditor();
  }

  canViewSettings(): boolean {
    return this.isRepositoryEditor();
  }

  canManage(): boolean {
    return this.isRepositoryAdmin();
  }

  canCreateBranch(): boolean {
    return this.isRepositoryAdmin();
  }

  canDelete(): boolean {
    return this.isRepositoryOwner();
  }

  canManageCollaborators(): boolean {
    return this.isRepositoryAdmin();
  }
}
